export const PageHero = ({ eyebrow, title, children, image, alt, testId, actions }) => (
  <section className="relative overflow-hidden border-b border-[#E5E0D8]" data-testid={testId}>
    <div className="container-site py-14 sm:py-20 grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-7 animate-rise">
        <span className="eyebrow">{eyebrow}</span>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1C2421] font-semibold leading-[1.08]">{title}</h1>
        <div className="lead mt-6 max-w-2xl space-y-4">{children}</div>
        {actions && <div className="mt-8">{actions}</div>}
      </div>
      {image && (
        <div className="lg:col-span-5 animate-rise delay-2">
          <div className="relative">
            <div className="absolute -inset-3 rounded-[2.25rem] bg-[#C86D51]/15 rotate-2" aria-hidden="true" />
            <img src={image} alt={alt} className="relative w-full aspect-[4/3] object-cover rounded-[2rem] border border-white" />
          </div>
        </div>
      )}
    </div>
  </section>
);

export const SectionHead = ({ eyebrow, title, children, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && <span className="eyebrow">{eyebrow}</span>}
    <h2 className="h2">{title}</h2>
    {children && <div className="lead mt-4">{children}</div>}
  </div>
);

export const IconCard = ({ icon: Icon, title, children, testId }) => (
  <div className="card-warm p-6 sm:p-7 h-full transition-transform duration-300 hover:-translate-y-1" data-testid={testId}>
    <div className="h-11 w-11 rounded-xl bg-[#F3EFEA] grid place-items-center mb-5">
      <Icon className="h-5 w-5 text-[#C86D51]" aria-hidden="true" />
    </div>
    <h3 className="text-lg font-semibold text-[#1C2421]">{title}</h3>
    <p className="text-sm text-[#5A6561] leading-relaxed mt-2">{children}</p>
  </div>
);

export const Notice = ({ children, testId }) => (
  <div className="rounded-xl border border-[#F5E6A3]/40 bg-[#FBF4E6] px-5 py-4 text-sm text-[#5A4A2A] leading-relaxed" data-testid={testId}>
    {children}
  </div>
);
